import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi, getToken, setToken } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
  const [ready, setReady] = useState(false);

  const check = useCallback(async () => {
    if (!getToken()) { setUser(false); setReady(true); return; }
    try { setUser(await authApi.me()); }
    catch { setToken(null); setUser(false); }
    finally { setReady(true); }
  }, []);

  useEffect(() => { check(); }, [check]);

  useEffect(() => {
    const onUnauth = () => { setToken(null); setUser(false); };
    window.addEventListener("xyz-unauthorized", onUnauth);
    return () => window.removeEventListener("xyz-unauthorized", onUnauth);
  }, []);

  const login = async (email, password) => {
    const res = await authApi.login(email, password);
    setToken(res.token);
    const full = await authApi.me().catch(() => res.user);
    setUser(full);
    return full;
  };
  const logout = async () => {
    try { await authApi.logout(); } catch { /* noop */ }
    setToken(null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, ready, login, logout, refresh: check }}>{children}</AuthCtx.Provider>;
};
